import React from "react";
import { TEvent } from "../../hooks/useSanity";
import "./eventCard.scss";
import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faMapMarker, faMinus } from "@fortawesome/free-solid-svg-icons";
import { urlFor } from "../../sanityClient";
interface IProps {
  salonEvent: TEvent | undefined;
}

export default function EventCard(props: IProps) {
  const { salonEvent } = props;
  return (
    <div className="ui-event-card">
      {salonEvent?.image ? (
        <div className="ui-event-card-image">
          <img
            src={urlFor(salonEvent.image)
              // .width(800)
              .quality(75) // Compress to 75% quality
              .auto("format") // Auto-select best image format (e.g., WebP)
              .url()}
            alt={salonEvent.title}
          />
        </div>
      ) : null}
      <div style={{ flex: "2" }}>
        <h1>{salonEvent?.title}</h1>
        <div className="ui-event-card-dates">
          <span>
            {DateTime.fromISO(salonEvent?.startDateTime ?? "", { zone: "utc" }) // read from UTC
              .toLocal()
              .toFormat("MMMM d, yyyy h:mm a")}
          </span>
          {salonEvent?.endDateTime ? (
            <span>
              {" "}
              -{" "}
              {DateTime.fromISO(salonEvent?.endDateTime ?? "", { zone: "utc" }) // read from UTC
                .toLocal()
                .toFormat("MMMM d, yyyy h:mm a")}
            </span>
          ) : null}
        </div>
        {salonEvent?.location ? (
          <a
            className="ui-event-card-url"
            href={`http://maps.google.com/?q=${salonEvent?.location}`}
            target="_blank"
            rel="noreferrer"
          >
            {salonEvent?.location} <FontAwesomeIcon icon={faMapMarker} />
          </a>
        ) : null}
        <p className="ui-event-card-description">{salonEvent?.description}</p>
        {salonEvent?.extraInfo && salonEvent?.extraInfo?.length > 0 ? (
          <div className="ui-event-card-info-container">
            {salonEvent?.extraInfo?.map((info, index) => (
              <div key={index} className="ui-event-card-info">
                <FontAwesomeIcon icon={faMinus} /> {info}
              </div>
            ))}
          </div>
        ) : null}
        {salonEvent?.eventUrl ? (
          <a href={salonEvent?.eventUrl} className="ui-event-card-url" target="_blank" rel="noreferrer">
            More Info <FontAwesomeIcon icon={faArrowRight} />
          </a>
        ) : null}
      </div>
    </div>
  );
}
